import { render, staticRenderFns } from "./productCountDetail.vue?vue&type=template&id=43f2b628&scoped=true&"
import script from "./productCountDetail.vue?vue&type=script&lang=js&"
export * from "./productCountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f2b628",
  null
  
)

export default component.exports